import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function over(event) {
  return true;
}
function enter(event) {
  return true;
}
function exit(event) {
  return true;
}
function end(event) {
  return true;
}
var DropTargetDelegateClass;
function DropTargetDelegate() {
  if (DropTargetDelegateClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DropTargetDelegate');
    DropTargetDelegateClass = $;
  }
  return DropTargetDelegateClass;
}
//region block: exports
export {
  end as end238hqoddg8oh0,
  enter as enterxt1o6yqg45ty,
  exit as exit1trjmdna0ewg5,
  over as over21zrvdp2w0cyt,
  DropTargetDelegate as DropTargetDelegatede6k5xrbmghq,
};
//endregion

//# sourceMappingURL=DropTargetDelegate.mjs.map
